package diana.soleil.design.iraniancanadienbazzar.core.model

/** Public community event (`events/{id}`), discovered in-app and ticketed on the organizer's site. */
data class Event(
    val id: String,
    val organizerUid: String,
    val title: LocalizedText,
    val description: LocalizedText = LocalizedText(),
    val coverUrl: String? = null,
    val startsAtMillis: Long,
    val endsAtMillis: Long? = null,
    val venue: EventVenue,
    val category: EventCategory = EventCategory.Culture,
    val metroId: String? = null,
    val ticketUrl: String? = null,
    val isFree: Boolean = false,
    val featured: Boolean = false,
    val status: EventStatus = EventStatus.Approved,
)

data class EventVenue(
    val name: String,
    val address: String = "",
    val city: String,
    val province: String = "",
)

enum class EventCategory { Music, Culture, Family, Business, Other }
enum class EventStatus { Pending, Approved, Rejected, Cancelled }
